// src/pages/Rent.js

import React from 'react';
import Header from '../components/Header.js'; // Assuming you have a Header component
import Footer from '../components/Footer.js'; // Assuming you have a Footer component

// --- Reusable Icon Components for this page ---
const DetailItem = ({ icon, label, value }) => (
    <div className="flex items-center text-sm text-gray-700">
        {icon}
        <span className="mr-2">{label}:</span>
        <strong className="text-gray-900">{value}</strong>
    </div>
);

const UtilityItem = ({ icon, label }) => (
    <div className="flex items-center text-gray-600">
        {icon}
        <span>{label}</span>
    </div>
);

// --- Sidebar Components ---
const SellerContact = () => (
    <div className="bg-white rounded-lg p-6 border border-gray-200">
        <h3 className="font-bold text-lg mb-4">Contact sellers</h3>
        <div className="flex items-center mb-6">
            <div className="w-16 h-16 rounded-full bg-gray-200 mr-4"></div>
            <div>
                {/* Contact details can be filled here */}
            </div>
        </div>
        <div className="space-y-2 text-sm text-gray-600 mb-4">
            <p><strong>Office Phone:</strong> <span className="text-gray-400">Your phone number</span></p>
            <p><strong>Mobile Phone:</strong> <span className="text-gray-400">Your phone number</span></p>
            <p><strong>Whatsapp:</strong> <span className="text-gray-400">Your whatsapp number</span></p>
            <p><strong>Email:</strong> <span className="text-gray-400">Your email</span></p>
        </div>
        <button className="w-full bg-black text-white py-2 rounded-md font-semibold hover:bg-gray-800">My other property</button>
    </div>
);

const TourForm = () => (
    <div className="bg-white rounded-lg p-6 mt-6 border border-gray-200">
        <h3 className="font-bold text-lg mb-1">Schedule tour</h3>
        <p className="text-sm text-gray-500 mb-4">See your future home up close! Schedule a tour with a property manager now and find the perfect property.</p>
        <form className="space-y-4 text-sm">
            <div>
                <label className="font-semibold text-gray-600">Property ID</label>
                <input type="text" readOnly value="556632191" className="w-full mt-1 p-2 bg-gray-100 border border-gray-300 rounded-md" />
            </div>
            <div>
                <label className="font-semibold text-gray-600">Property name</label>
                <input type="text" readOnly value="RPA Centre" className="w-full mt-1 p-2 bg-gray-100 border border-gray-300 rounded-md" />
            </div>
            <div>
                <label className="font-semibold text-gray-600">Name</label>
                <input type="text" placeholder="Your name" className="w-full mt-1 p-2 bg-gray-100 border border-gray-300 rounded-md" />
            </div>
            <div>
                <label className="font-semibold text-gray-600">Email</label>
                <input type="email" placeholder="Your email" className="w-full mt-1 p-2 bg-gray-100 border border-gray-300 rounded-md" />
            </div>
            <div>
                <label className="font-semibold text-gray-600">Phone</label>
                <input type="tel" placeholder="Your phone" className="w-full mt-1 p-2 bg-gray-100 border border-gray-300 rounded-md" />
            </div>
            <div>
                <label className="font-semibold text-gray-600">Message</label>
                <textarea placeholder="Message" rows="4" className="w-full mt-1 p-2 bg-gray-100 border border-gray-300 rounded-md"></textarea>
            </div>
            <button type="submit" className="w-full bg-orange-500 text-white py-3 rounded-md font-bold hover:bg-orange-600">Submit</button>
        </form>
    </div>
);

// --- Component for the Sidebar Properties ---
const SidebarPropertyCard = ({ name, price }) => (
    <a href="#" className="block bg-white rounded-lg p-3 border border-gray-200 hover:shadow-md transition-shadow duration-200">
        <div className="flex gap-4">
            <div className="w-24 h-24 bg-gray-200 rounded-md flex-shrink-0 flex items-center justify-center">
                 <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
            </div>
            <div>
                <div className="flex gap-2 mb-2">
                    <span className="text-xs font-semibold px-2 py-0.5 bg-orange-100 text-orange-800 rounded">Uncategory</span>
                    <span className="text-xs font-semibold px-2 py-0.5 bg-gray-800 text-white rounded">Rent</span>
                </div>
                <h4 className="font-bold text-gray-800">{name}</h4>
                <p className="text-sm text-gray-500 mt-1">Johannesburg</p>
                <p className="font-bold text-lg text-black mt-2">ZAR {price}</p>
            </div>
        </div>
    </a>
);

// --- Component for the Related Properties Section ---
const RelatedProperties = () => {
    // You'll need the full `PropertyCard` component from your Requirements.js page for this to work.
    // Make sure it is defined or imported in Rent.js.
    const properties = [
        { category: "Uncategory", status: "Rent", location: "Johannesburg", name: "2", beds: 0, baths: 0, sqft: 0, agentName: "Agent name", price: "0" },
        { category: "Uncategory", status: "Rent", location: "Johannesburg", name: "4", beds: 0, baths: 0, sqft: 0, agentName: "Agent name", price: "0" },
        { category: "Uncategory", status: "Rent", location: "Johannesburg", name: "5", beds: 0, baths: 0, sqft: 0, agentName: "Agent name", price: "0" },
    ];

    return (
        <section className="mt-16">
            <h2 className="text-3xl font-extrabold text-black mb-8 tracking-wide">RELATED PROPERTIES</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {properties.map((prop, index) => (
                    // This assumes you have the PropertyCard component available in this file
                    // <PropertyCard key={index} {...prop} />
                    // Placeholder until you import PropertyCard:
                     <div key={index} className="h-96 bg-gray-100 border rounded-lg p-4">Card for "{prop.name}"</div>
                ))}
            </div>
        </section>
    );
};

// --- Main Page Component ---
const Rent = () => {
    return (
        <div className="bg-gray-50">
            <Header />
            <main className="container mx-auto px-6 lg:px-8 py-8 mt-20">
                {/* --- Header Section --- */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
                    <div>
                        <span className="text-xs font-semibold px-2 py-1 bg-orange-100 text-orange-800 rounded">For Rent</span>
                        <h1 className="text-4xl font-extrabold text-black mt-2">RPA CENTRE</h1>
                        <div className="flex flex-wrap gap-x-6 gap-y-2 mt-4 text-gray-600">
                            <div className="flex items-center">
                                <span className="font-semibold mr-1">Beds:</span> 4
                            </div>
                            <div className="flex items-center">
                                <span className="font-semibold mr-1">Baths:</span> 2
                            </div>
                            <div className="flex items-center">
                                <span className="font-semibold mr-1">Sqft:</span> 1150
                            </div>
                            <div className="flex items-center">
                                <span className="font-semibold mr-1">Location:</span> Johannesburg
                            </div>
                        </div>
                    </div>
                    <div className="mt-4 md:mt-0 text-right">
                        <p className="text-3xl font-bold text-black">ZAR 0 <span className="text-lg font-normal text-gray-500">/Month</span></p>
                    </div>
                </div>

                {/* --- Main Content Grid --- */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* --- Left Column --- */}
                    <div className="lg:col-span-2">
                        <div className="w-full h-96 bg-gray-200 rounded-lg mb-8"></div> {/* Main Image Placeholder */}
                        
                        <h2 className="text-2xl font-bold mb-4">Description</h2>
                        <p className="text-gray-600 mb-8">
                            {/* Add property description text here */}
                        </p>

                        <h2 className="text-2xl font-bold mb-4">Property features</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mb-8 p-6 bg-white rounded-lg border border-gray-200">
                            <DetailItem label="Size" value="0 m2" />
                            <DetailItem label="Bedrooms" value="0" />
                            <DetailItem label="Bathrooms" value="0" />
                            <DetailItem label="Floor" value="0" />
                            <DetailItem label="Additional Space" value="" />
                            <DetailItem label="Furnishing" value="" />
                            <DetailItem label="Ceiling Height" value="0 m" />
                            <DetailItem label="Construction Year" value="Sep 12, 2025" />
                            <DetailItem label="Renovation" value="Sep 12, 2025" />
                        </div>

                        <h2 className="text-2xl font-bold mb-4">Property utility</h2>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8 p-6 bg-white rounded-lg border border-gray-200">
                            <UtilityItem label="Heating" />
                            <UtilityItem label="Air Condition" />
                            <UtilityItem label="Fireplace" />
                            <UtilityItem label="Elevation" />
                            <UtilityItem label="Ventilation" />
                            <UtilityItem label="Intercom" />
                            <UtilityItem label="Window Type" />
                            <UtilityItem label="Cable TV" />
                            <UtilityItem label="Wifi" />
                        </div>
                        
                        <h2 className="text-2xl font-bold mb-4">Location</h2>
                        <div className="p-6 bg-white rounded-lg border border-gray-200 mb-8">
                            <p className="text-gray-700 mb-4">16th Avenue, Fairlands, Randburg</p>
                            <button className="bg-black text-white font-semibold py-2 px-5 rounded-md hover:bg-gray-800">Show on map</button>
                        </div>

                        <h2 className="text-2xl font-bold mb-4">Gallery</h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                             <div className="md:col-span-3 h-80 bg-gray-200 rounded-lg"></div>
                             <div className="h-40 bg-gray-200 rounded-lg"></div>
                             <div className="h-40 bg-gray-200 rounded-lg"></div>
                             <div className="h-40 bg-gray-200 rounded-lg"></div>
                        </div>

                         <h2 className="text-2xl font-bold mb-4">Video</h2>
                         <div className="w-full h-80 bg-purple-100 border-2 border-dashed border-purple-400 rounded-lg flex items-center justify-center">
                             <p className="text-purple-600">To embed a Youtube video, add the URL to the properties panel.</p>
                         </div>
                    </div>

                    

                    {/* --- Right Sidebar Column --- */}
        <div className="lg:col-span-1">
                        <SellerContact />
                        <TourForm />
                        {/* More in Johannesburg section can be added here if needed */}
                         {/* ADD THIS SECTION FOR MORE PROPERTIES */}
        <div className="bg-gray-100 rounded-lg p-6 mt-6 border border-gray-200">
               <h3 className="font-bold text-lg mb-4">More in Johannesburg</h3>
            <div className="space-y-4">
                <SidebarPropertyCard name="2" price="0" />
                <SidebarPropertyCard name="3" price="0" />
            </div>
        </div>
    </div>
 </div>
  </main>
            
        </div>
    );
};

export default Rent;